import React, { useEffect, useState } from 'react';
import { Switch, TextBox } from '@progress/kendo-react-inputs';
import { ComboBox, DropDownList } from '@progress/kendo-react-dropdowns';

import DeleteIcon from "../../../assets/shuttle_bus_booking/delete.svg";
import DownArrowIcon from "../../../assets/shuttle_bus_booking/ic_down_arrow.svg";
import { ShowDialog } from '../../../components/reusableItems/dialog';
import { Button } from '@progress/kendo-react-buttons';

export const ManageRoute = (props) => {
    const [showDelete, setShowDelete] = useState(false);
    const [tempId, setTempId] = useState("");

    const [stationCombo, setStationCombo] = useState([]);
    const [allStations, setAllStations] = useState([]);

    const actionTrigger = () => {
        const newRoutes = props.routes
            .filter(r => r.station_id !== tempId)
            .map((r, i) => ({
                ...r,
                order_no: i + 1
            }));
        props.setRoutes(newRoutes);
        setShowDelete(false);
        setTempId('');
    };

    useEffect(() => {
        refreshStationList();
    }, [props.routes, props.stations]);

    const refreshStationList = () => {
        if (props.stations) {
            const allStations = props.stations;
            const existingIds = new Set(props.routes.map(r => r.station_id));
            const missingStations = allStations.filter(s => !existingIds.has(s.station_id));

            setAllStations(missingStations);
            setStationCombo(missingStations);
        }
    };

    const filterChangeStationName = (event) => {
        const filterText = String(event.filter?.value ?? '').toLowerCase();

        const filtered = allStations.filter(item => {
            const idStr = String(item.station_id).toLowerCase();
            const nameStr = (item.station_name || '').toLowerCase();
            return idStr.includes(filterText) || nameStr.includes(filterText);
        });

        setStationCombo(filtered);
    };

    const handleChangeStationName = (event) => {
        console.log("Selected value:", event.target.value);
    };

    return (
        <div>
            {showDelete && (
                <ShowDialog
                    title={"Please Confirm!"}
                    content={"Are you sure you want to delete?"}
                    cancelContent={"Cancel"}
                    confrimContent={"Delete"}
                    cancelbtn={() => setShowDelete(false)}
                    confrinbtn={actionTrigger}
                />
            )}

            <div className="shuttle-bus-booking-item-main-box">
                {props.routes.map((route, index) => (
                    <div key={route.station_id ?? index}>
                        {index !== 0 &&
                            <img src={DownArrowIcon} className="shuttle-bus-booking-down-arrow-icon" />
                        }
                        <div className="shuttle-bus-booking-item-row">

                            <div className="shuttle-bus-booking-main-box">
                                <div className="shuttle-bus-booking-item-title">
                                    Station Name <span style={{ color: "red" }}>*</span>
                                </div>
                                <div>
                                    <ComboBox
                                        id={`shuttle-bus-booking-station-${index}`}
                                        data={stationCombo}
                                        textField="station_name"
                                        dataItemKey="station_id"
                                        filterable={true}
                                        onFilterChange={filterChangeStationName}
                                        style={{ width: '100%' }}
                                        onChange={(e) => {
                                            const newRoutes = [...props.routes];
                                            // ✅ Create a new object instead of mutating the original
                                            newRoutes[index] = {
                                                ...newRoutes[index],
                                                station_id: e.value?.station_id || "",
                                                station_name: e.value?.station_name || "",
                                            };
                                            props.setRoutes(newRoutes);
                                            refreshStationList();
                                        }}
                                        value={route}
                                        placeholder="Choose Station"
                                        itemRender={(li, itemProps) => {
                                            const item = itemProps.dataItem || {};
                                            const name = item.station_name;
                                            return React.cloneElement(li, li.props, `${name}`);
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="shuttle-bus-booking-main-box">
                                <div className="shuttle-bus-booking-item-title">
                                    Time <span style={{ color: "red" }}>*</span>
                                </div>
                                <div>
                                    <TextBox
                                        className="shuttle-bus-booking-item-field"
                                        value={route?.time}
                                        onChange={(e) => {
                                            const numericOnly = e.target.value.replace(/[^0-9]/g, '');
                                            const newRoutes = [...props.routes];
                                            newRoutes[index] = {
                                                ...newRoutes[index],
                                                time: numericOnly,
                                            };
                                            props.setRoutes(newRoutes);
                                        }}
                                    />
                                    {(props.showValidateError && !route.time) && (
                                        <div className="shuttle-bus-booking-error-text">{'Required Field'}</div>
                                    )}
                                </div>
                            </div>

                            <div className="shuttle-bus-booking-delete-button-container">
                                <div
                                    className="shuttle-bus-booking-delete-button"
                                    onClick={() => {
                                        setTempId(route?.station_id);
                                        setShowDelete(true);
                                    }}
                                >
                                    <img src={DeleteIcon} className="shuttle-bus-booking-delete-button-icon" />
                                </div>
                            </div>

                        </div>
                    </div>
                ))}

                {allStations.length > 0 && (
                    <Button
                        className="shuttle-bus-booking-detail-btn font-family-poppins"
                        onClick={() => {
                            const firstStation = allStations[0];
                            const newRoute = {
                                station_id: firstStation.station_id,
                                time: "",
                                order_no: props.routes.length + 1,
                                station_name: firstStation.station_name,
                            };
                            props.setRoutes([...props.routes, newRoute]);
                        }}
                    >
                        + Add
                    </Button>
                )}
            </div>
        </div>
    );
};

const itemRender = (li, itemProps) => {
    return React.cloneElement(li, {
        style: {
            height: "48px",
            lineHeight: "48px",
        },
    });
};